
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const SaveMultiple20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M5 3a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6.62a2 2 0 0 0-.59-1.41L12.8 3.59A2 2 0 0 0 11.38 3H5ZM4 5a1 1 0 0 1 1-1h1v1.5C6 6.33 6.67 7 7.5 7h2c.83 0 1.5-.67 1.5-1.5V4h.38a1 1 0 0 1 .7.3l1.63 1.61a1 1 0 0 1 .29.71V13a1 1 0 0 1-1 1v-3.5c0-.83-.67-1.5-1.5-1.5h-5C5.67 9 5 9.67 5 10.5V14a1 1 0 0 1-1-1V5Zm3 .5V4h3v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5Zm5 5V14H6v-3.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5ZM8.5 17c-.95 0-1.82-.38-2.45-1h7.45a2.5 2.5 0 0 0 2.5-2.5V6.05c.62.63 1 1.5 1 2.45v5a3.5 3.5 0 0 1-3.5 3.5h-5Z"
            fill="currentColor"
        />
    </svg>
}